import  { FC, memo, useEffect } from 'react';
// Hooks
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Actions
import { setMounted } from 'store/rokt/roktSlice';
// Selectors
import { selectPlayerData, selectMounted } from 'store/rokt/roktSelectors';
import { selectQuiz, selectQuizIntegrationConfig } from 'store/quiz/quizSelectors';
// Models
import IQuiz from 'models/Quiz';
// Types
import QuizTypes from 'types/QuizTypes';
import QuizIntegrations from 'types/QuizIntegrations';

const RoktIntegration:FC = () => {
  const dispatch = useAppDispatch();

  const mounted = useAppSelector(selectMounted);
  const playerData = useAppSelector(selectPlayerData);
  const quiz:IQuiz = useAppSelector(selectQuiz);

  
  const config = useAppSelector((state) => selectQuizIntegrationConfig(state, { integrationName: QuizIntegrations.Rokt }));

  const roktIntegration = async () => {
    const target = document.head || document.body;
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://apps.rokt.com/wsdk/integrations/launcher.js";
    (script as any).fetchpriority = "high";
    script.crossOrigin = "anonymous";
    script.async = true;
    target.appendChild(script);

    const launcherPromise = new Promise((resolve, reject) => {
      script.onload = () =>
        resolve((window as any).Rokt.createLauncher({ accountId: config?.accountId, sandbox: true }));
      script.onerror = (error) => reject(error);
    });

    const launcher: any = await launcherPromise;

    await launcher.selectPlacements({
      attributes: {
        ...playerData,
        merchantid: config?.merchantId,
      
      },
      identifier: "post-quiz-page",
    });
  }

  const enabled = quiz.integrations?.some(integration => integration.service === QuizIntegrations.Rokt);

  useEffect(() => {
    if (
      !mounted && playerData && enabled && !!config
        && [QuizTypes.Scoring, QuizTypes.Prediction].includes(quiz.type)
        && !!quiz.registrationPage && !quiz.registrationPage.anonymous
      ) {
      roktIntegration();
      dispatch(setMounted());
    }
    // eslint-disable-next-line
  }, []);

  return null;
}

export default memo(RoktIntegration);
